"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealVkusvillLcmlLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealVkusvillLcmlLinear = function MealVkusvillLcmlLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M33.567 16.648l1.379.062a11.609 11.609 0 01-10.922 7.657H12.29a3.277 3.277 0 00-3.278 3.446 3.4 3.4 0 003.462 3.063h2.405l.934-1.057a2.82 2.82 0 012.099-.934h4.779a.398.398 0 01.291.659l-3.064 3.338A3.34 3.34 0 0117.437 34H12.32A8.686 8.686 0 014 25.324a8.682 8.682 0 018.32-8.676h21.247z",
    stroke: "#95A0B3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 21.25a1.25 1.25 0 111.04-1.945l.623-.416-.624.416A1.25 1.25 0 0126 21.25z",
    stroke: "#95A0B3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.076 15.5c.031-.363.033-.752.008-1.132-.039-.602-.145-1.222-.328-1.713l-.008-.021-.01-.02a5.094 5.094 0 00-3.277-2.73l-.092-.031.074-.218.11.037.014.005.014.004c.742.205 1.43.57 2.015 1.07.57.488 1.051 1.158 1.373 1.859.26.834.401 1.957.367 2.89h-.26zm-1.43-.472c.102.165.204.387.29.727l-.09.055a3.778 3.778 0 00-.889-1.252c-2.335-2.547-7.7-4.21-13.156-2.513h0-.002l-.105.034-.067-.21.105-.033c5.695-1.774 11.073.01 13.404 2.584h0l.002.003.122.13c.156.167.274.293.386.475z",
    stroke: "#95A0B3"
  }));
};

exports.MealVkusvillLcmlLinear = MealVkusvillLcmlLinear;
var _default = MealVkusvillLcmlLinear;
exports.default = _default;